(function () {
    document.addEventListener("DOMContentLoaded", () => {
        setTimeout(() => {
            const ad = document.querySelector(".app__container .globo-form-app .panels + p");

            if (!ad) return null;

            ad.style.display = "none";
        }, 500);
    });
})();
